
<div class="register-container">
  <div class="row row-1">
    <div class="col-sm-7 col-1">
      <h2 class="overview-header register-header">Add Account</h2>
    </div>
    <div class="col-sm-5 col-2">
    </div>
  </div>

  <div class="card" style="">
    <div class="card-body" style="margin-bottom: 3%;">
      <div class="row register-row">
        <div class="col-sm-12">
          <div class="btn-group btn-group-toggle" data-toggle="buttons" style="width: 100%;border-bottom: 1px solid #3F8F8B;">
              <label #registerbill class="btn btn-secondary active" (click)="usingBillInfo()">
                <input type="radio" name="options" id="option2" autocomplete="off" checked><i class="fas fa-envelope-open register-icon"></i>FIND USING BILL INFO
              </label>
              <label #registerpersonalinfo class="btn btn-secondary" style="margin-right: 0rem;" (click)="usingPersonalInfo()">
                <input type="radio" name="options" id="option3" autocomplete="off"><i class="fas fa-user register-icon"></i>FIND USING PERSONAL INFO
              </label>
          </div>
        </div>
      </div>

      <div *ngIf="showBill" class="register-bill-container" id="registerbill">

        <div class="row register-row bp-text bp-small-text" style="margin-top: 2.5%;margin-bottom: .3%;">
          <div class="col-sm-12">
            <p class="color: #777;">All fields are required.</p>
          </div>
        </div>

        <div class="row">
          <div class="alert alert-danger col-sm-12" role="alert" *ngIf="billNotFound">
            <i class="fas fa-exclamation-triangle" style="margin-right: 0.4rem;"></i>
            <span>Sorry, we were unable to locate any accounts with the information provided.</span>
          </div>
        </div>

        <div class="row register-row">
          <div class="col-sm-6">
            <form #registrationBillInfoForm="ngForm">
              <div class="form-group bill-info-form-group">
                <label for="registerAccountNumber" class="bp-text login-label bp-small-text">Account Number</label>
                <input #accountNumber="ngModel" [(ngModel)]="customer.accountNumber" name="accountNumber" required type="text" class="form-control input-register-acct-number" id="registerAccountNumber">
                <div [hidden]="accountNumber.valid || accountNumber.pristine" class="alert alert-danger account-number-alert">Please enter Account Number</div>
                <label for="registerWebAccessCode" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Web Access Code</label>
                <input #webAccessCode="ngModel" [(ngModel)]="customer.webAccessCode" name="webAccessCode" required type="text" class="form-control input-register-web-access-code" id="registerWebAccessCode">
                <div [hidden]="webAccessCode.valid || webAccessCode.pristine" class="alert alert-danger alert-web-access-code">Please enter Web Access Code</div>
              </div>
              <div class="form-group" style="margin-bottom: 2rem;">
                <re-captcha class="recaptcha" required name="captcha" [(ngModel)]="captcha" (resolved)="resolvedCaptcha($event)"></re-captcha>
              </div>
              <div class="form-group">
                <button type="submit" [disabled]="!registrationBillInfoForm.form.valid" class="btn btn-primary bp-text" (click)="onLookupClick()">LOOKUP ACCOUNT</button>
                <span><a class="bp-link-blue" (click)="onCancel()">CANCEL</a></span>
              </div>
            </form>
          </div>
          <div class="col-sm-6">
            <p style="font-size: 2.2rem;text-align: center;margin-bottom: 0rem;">
              Find your account information on your bill.
            </p>
            <br />
            <span><img class="bill-info-img" src="../../assets/bill-illustration.png" height="42" width="42"></span>
          </div>
        </div>
      </div>
      <div *ngIf="showPersonal" class="register-personal-info-container">
        <div class="row register-row">
          <div class="col-sm-12 col-no-padding" style="margin-top: 2rem;">
            <p class="bp-text bp-medium-text"><span class="bp-bold-text">Access using Personal Information is for Residential Customers only.</span> The requested information pertains to the person who established the account.</p>
          </div>
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="personalInfoNotFound">
          <i class="fas fa-exclamation-triangle" style="margin-right: 0.4rem;"></i>
          <span>Sorry, we were unable to locate any accounts with the information provided.</span>
        </div>
        <div class="row register-row bp-text bp-small-text" style="margin-top: 1.5%;margin-bottom: .3%;">
          <p class="color: #777;">All fields are required.</p>
        </div>
        <div class="row register-row">
          <div class="col-sm-6">
            <form #registrationPersonalInfoForm="ngForm">
              <div class="form-group bill-info-form-group">

                <label for="registerFirstName" class="bp-text login-label bp-small-text">First Name</label>
                <input #firstName="ngModel" [(ngModel)]="customer.firstName" name="firstName" required type="text" class="form-control form-input-6" id="registerFirstName">
                <div [hidden]="firstName.valid || firstName.pristine" class="alert alert-danger register-alert-6">Please enter First Name</div>

                <label for="registerLastName" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Last Name</label>
                <input #lastName="ngModel" [(ngModel)]="customer.lastName" name="lastName" required type="text" class="form-control form-input-6" id="registerlastName">
                <div [hidden]="lastName.valid || lastName.pristine" class="alert alert-danger register-alert-6">Please enter Last Name</div>

                <label for="registerLast4" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Last 4 of SSN</label>
                <input #last4OfSSN="ngModel" [(ngModel)]="customer.lastFourSSN" name="last4OfSSN" required type="text" class="form-control form-input-6" id="registerlast4OfSSN">
                <div [hidden]="last4OfSSN.valid || last4OfSSN.pristine" class="alert alert-danger register-alert-6">Please enter Last 4 of SSN</div>

                <label for="registerPropertyZip" class="bp-text login-label bp-small-text" style="margin-top: 1.8rem;">Zip Code of Property</label>
                <input #propertyZip="ngModel" [(ngModel)]="customer.zipCode" name="propertyZip" required type="text" class="form-control form-input-6" id="registerpropertyZip">
                <div [hidden]="propertyZip.valid || propertyZip.pristine" class="alert alert-danger register-alert-6">Please enter Property Zip Code</div>
              </div>
              <div class="form-group" style="margin-bottom: 2rem;">
                <re-captcha class="recaptcha" required name="captcha" [(ngModel)]="captcha" (resolved)="resolvedCaptcha($event)"></re-captcha>
              </div>
              <div class="form-group">
                <button type="submit" [disabled]="!registrationPersonalInfoForm.form.valid" class="btn btn-primary bp-text" (click)="onLookupClick()">LOOKUP ACCOUNT</button>
                <span><a class="bp-link-blue" (click)="onCancel()">CANCEL</a></span>
              </div>
            </form>
          </div>
          <div class="col-sm-6">
            <span><img class="bill-info-img" src="../../assets/bill-personalinfo-illustration.png" height="42" width="42"></span>
          </div>
        </div>
      </div>
    </div>
    <footer class="blockquote-footer water-usage-footer"></footer>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/add-account-container/add-account-container.component.html